import React, { Component, createRef, Fragment } from 'react';
import Axios from 'axios';
import { connect } from 'react-redux';
import downloadjs from 'downloadjs';
import * as actions from '../actions';
import Step1 from './doctor_resource_guide_drp_steps/Step1';
import Step2 from './doctor_resource_guide_drp_steps/Step2';
import Step3 from './doctor_resource_guide_drp_steps/Step3';
import Step4 from './doctor_resource_guide_drp_steps/Step4';
import Step5 from './doctor_resource_guide_drp_steps/Step5';
import Step6 from './doctor_resource_guide_drp_steps/Step6';
import Step7 from './doctor_resource_guide_drp_steps/Step7';
import Step8 from './doctor_resource_guide_drp_steps/Step8';
import Step9Caregiver from './doctor_resource_guide_drp_steps/Step9Caregiver';
import Step9Patient from './doctor_resource_guide_drp_steps/Step9Patient';
import Step10 from './doctor_resource_guide_drp_steps/Step10';
import Finish from './doctor_resource_guide_drp_steps/Finish';
import Wizard from './helpers/healthcareDRPWizard.js';

class DoctorResourceGuideDRPForm extends Component {

    constructor(props) {
        super(props)
        this.state = {
            submitted: false,
            pdfUrl: false,
            DoctorResourceGuideDRPFormItems: null,
        }
    }
    
    onSubmit = async (values) => {
        const reactState = this;
        let url = "/";
        if(process.env.NODE_ENV === "development") {
            url = "http://localhost:8000/"
        }
        values.formType = 'DoctorResourceGuideDRP';

        try {
            await Axios({
                method: 'post',
                url: url + "api/generate_pdf",
                data: values,
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded'
                }
            })
            .then(function (res) {
                reactState.setState({
                    ...reactState.state,
                    // pdfUrl: url + res.data.file,
                    submitted: true
                });
                downloadjs(url + res.data.file);
            });
            this.props.submit(true);

        }
        catch(errors) {
            console.log("errors", errors)
        }

        this.setState({
             ...this.state,
             submitted: true
        });
    }

    toTop = createRef();

    render() {
        const { submitted } = this.state;
        const { userType } = this.props.questionOptions;
        let backgroundColor = "inherit"

        if(process.env.NODE_ENV === "development") {
            backgroundColor = "black";
        }
        
        return (
            <div className="acadia-form drp-form" ref={this.toTop} style={{background: backgroundColor}}>
                <Wizard onSubmit={this.onSubmit} noOfPages={userType === "caregiver" ? 10 : 9} submitted={submitted} toTop={this.toTop}>
                    <Wizard.Page>
                        <Step1 />
                    </Wizard.Page>
                    <Wizard.Page>
                        <Step2 />
                    </Wizard.Page>
                    <Wizard.Page>
                        <Step3 />
                    </Wizard.Page>
                    <Wizard.Page>
                        <Step4 />
                    </Wizard.Page>
                    <Wizard.Page>
                        <Step5 />
                    </Wizard.Page>
                    <Wizard.Page>
                        <Step6 />
                    </Wizard.Page>
                    <Wizard.Page>
                        <Step7 />
                    </Wizard.Page>
                    <Wizard.Page>
                        <Step8 />
                    </Wizard.Page>
                    {userType === "caregiver" && (
                        <Wizard.Page>
                            <Step9Caregiver />
                        </Wizard.Page>
                    )}
                    {userType === "caregiver" && (
                        <Wizard.Page>
                            <Step10 />
                        </Wizard.Page>
                    )}
                    {userType === "patient" && (
                        <Wizard.Page>
                            <Step9Patient />
                        </Wizard.Page>
                    )}
                    <Wizard.Page>
                        <Finish />
                    </Wizard.Page>
                </Wizard>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
  const { questionOptions } = state;
  return { questionOptions: questionOptions};
}

export default connect(mapStateToProps, actions)(DoctorResourceGuideDRPForm);